import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectAccountingCapitalBalance } from 'src/store/selectors/contractSelectors';
import AccountingCapitalBalanceTable from './AccountingCapitalBalanceTable';

const AccountingCapitalBalance = ({ className, ...rest }) => {
  const balanceList = useSelector(selectAccountingCapitalBalance);

  return (
    <Box display="flex" flexDirection="column" {...rest}>
      <AccountingCapitalBalanceTable balanceList={balanceList} />
    </Box>
  );
};

AccountingCapitalBalance.propTypes = {
  className: PropTypes.string
};

export default AccountingCapitalBalance;
